module.exports = __webpack_public_path__ + "static/media/optumhomepage.671b39f8.jpg";